import { useAuthStore } from '../store/authStore';
import type { LoginCredentials } from '../types/auth';

/**
 * Custom hook for authentication operations
 * Provides a convenient interface to the auth store
 */
export function useAuth() {
  const {
    user,
    isAuthenticated,
    isLoading,
    error,
    login,
    logout,
    setUser,
    clearError,
    checkAuth,
    refreshUser,
  } = useAuthStore();

  return {
    // State
    user,
    isAuthenticated,
    isLoading,
    error,

    // Actions
    login: async (credentials: LoginCredentials) => {
      await login(credentials);
    },
    logout: async () => {
      await logout();
    },
    setUser,
    clearError,
    checkAuth: async () => {
      await checkAuth();
    },
    refreshUser: async () => {
      await refreshUser();
    },

    // Computed values
    isAdmin: user?.roles?.includes('Admin') || false,
    isSupervisor: user?.roles?.includes('Supervisor') || false,
    isSubcontractor: user?.subcontractor || false,
    fullName: user?.fullName || '',
    email: user?.email || '',
    roles: user?.roles || [],
  };
}
